import React from "react";
import SectionHeader from "../SectionHeader";

const INTEGRATIONS = [
  { name: "Tally", icon: "📒" },
  { name: "GST Portal", icon: "🧾" },
  { name: "Razorpay", icon: "💳" },
  { name: "WhatsApp Business", icon: "💬" },
  { name: "Shopify", icon: "🛒" },
  { name: "Google Workspace", icon: "📧" },
  { name: "SMS Gateways", icon: "📱" },
  { name: "Biometric Devices", icon: "🔐" },
  { name: "Shiprocket", icon: "📦" },
  { name: "Excel Import/Export", icon: "📊" },
  { name: "Open GraphQL API", icon: "🧬" },
];

const IntegrationsStrip = () => (
  <section className="section section--muted">
    <SectionHeader
      eyebrow="Plays well with others"
      title="Connects to the tools you already use"
      lead="Byteflow products ship with ready integrations for the Indian business stack — and an API for everything else."
    />
    <div className="integrations">
      {INTEGRATIONS.map((i) => (
        <div key={i.name} className="integration-chip">
          <span aria-hidden>{i.icon}</span> {i.name}
        </div>
      ))}
    </div>
  </section>
);

export default IntegrationsStrip;
